import { IFieldsData, IValidate } from '@components/LeavePopup/types'

const REGEX_EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const validate: IValidate = {
  name: (name: string) => /^[а-яА-ЯёЁ\-—\s]+$/.test(name),
  email: (email: string) => REGEX_EMAIL.test(email),
  question: (question: string) => /^[а-яА-ЯёЁ0-9\s\W_]+$/.test(question),
}

export const captchaDataDefault = {
  code: '',
  imageURL: '',
  inputFieldValue: '',
}

export const fieldsDataInit: IFieldsData = {
  name: {
    data: '',
    isValid: true,
  },
  email: {
    data: '',
    isValid: true,
  },
  question: {
    data: '',
    isValid: true,
  },
}

export const api = {
  captcha: '/local/_ajax/capcha/',
  submit: '/local/_ajax/aero_form/',
  video: '/api/kpp-lp-videos/',
}

export enum ApiResponseStatuses {
  error = 'error',
  success = 'success',
}

export enum ErrorMessages {
  captchaFalse = 'captcha_false',
}
